import React from "react";
import { message } from "antd";
import { Messages } from "../CommonMessages";

const AdnMessageSuccess = (text = Messages.OperationSuccess) => {
  return message.success(text);
};

export default AdnMessageSuccess;
